export function slugify(word:string)
{
    if(word)
    return word
        ?.toLowerCase()
        ?.replace(/ /g,'-')
        ?.replace(/[^\w-]+/g,'')
        ;
        else return word;
}